











import {Vue, Component, Prop} from 'vue-property-decorator';
import {PayrollDetailsDTO} from "@/dto/payroll/PayrollDTO";
import Application from "@/state/Application";
import PayrollService from "@/services/payroll/PayrollService";
import {processError} from "@/utils/ComponentUtils";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import {prettyEnum} from "@/utils/StringUtils";
import Notifications from "@/state/Notifications";
import moment from "moment";
import PayrollFileDTO from "@/dto/payroll/PayrollFileDTO";
import PayrollDetailsReportView from "@/components/payroll/reports/payroll_details/PayrollDetailsReportView.vue";
import PatriotPayrollDetailsView from "@/components/payroll/reports/payroll_details/PatriotPayrollDetailsView.vue";

@Component({
	components: {PatriotPayrollDetailsView, PayrollDetailsReportView}
})
export default class PayrollDetailsReport extends Vue {
	@Prop()
	private report!: PayrollDetailsDTO | PayrollFileDTO

	private download() {
		this.$docUtils.download(this.report.fileMeta.id)
	}

	private voidPayroll() {
		Application.startLoading()
		PayrollService.voidPayroll((this.report as PayrollDetailsDTO).payrollId).then(
			() => {
				Notifications.success(`The paystub from ${moment(this.report.reportStart).format("MM/dd/yyyy")} to ${moment(this.report.reportEnd).format("MM/dd/yyyy")} has been successfully deleted`)
				this.$emit('void', this.report.id)
				Application.stopLoading();
			},
			err => processError(err, this)
		)
	}

	private deletePayroll() {
		Application.startLoading()
		PayrollService.deleteDocument(this.report.id!, 'PAYROLL_FILE').then(
			() => {
				Notifications.success(`The paystub has been successfully deleted`)
				this.$emit("delete", this.report.id)
				Application.stopLoading()
			},
			err => processError(err, this)
		)
	}

	private void() {
		if (this.report.generatedBy == 'SUBLIME') {
			this.$modal.show(
				DeleteConfirmation,
				{
					targetName: prettyEnum(this.report.reportType),
					operationName: "void",
					onDelete: this.voidPayroll
				}
			)
		} else {
			this.$modal.show(
				DeleteConfirmation,
				{
					targetName: prettyEnum(this.report.reportType),
					onDelete: this.deletePayroll
				}
			)
		}
	}
}
